import { formatDate_YMD, timeParseNoNull2 } from "@/_core/_helpers/_helpers";
import { apiService } from "@/_services";

/**
 * Fetches exposure data with valuation for unsettled exposure.
 * @param {object} _this - Context containing state variables.
 * @param {string} fieldName - Name of the field to update.
 * @param {boolean} fieldShowLoadingName - Flag to show loading indicator.
 * @param {Date|null} initialDate - Initial date (defaults to today).
 */
export function getAnalyticsCurrency(
  _this,
  fieldName,
  fieldShowLoadingName,
  initialDate = null,
) {
  initialDate = initialDate != null ? initialDate : new Date();
  _this[fieldShowLoadingName] = true;
  let params = {
    method: "POST",
    endpoint: "analytics_currency",
    content_type: "application/json",
    query_params: {
      companies: {
        id_companies: _this.selectedCompanies.map((d) => d.pk_idcompany),
      },
      date: formatDate_YMD(initialDate),
      assetsNums: {
        id_assets: _this.selectedAsset.map((d) => d.pk_i_idcurrency),
      },
      format: "json",
      portfolios: { id_portfolios: _this.portfolioNumbers },
    },
  };
  let dateFieldsExpo = [
    "date",
    "expiration_date",
    "hedged_date",
    "issue_date",
    "planned_expiration_date",
    "realized_expiration_date",
    "sale_date",
    "shipping_date",
    "updated_at",
  ];
  let dateFieldsHedge = [
    "asian_fixing_start_date",
    "created_at",
    "fixing_date",
    "hedged_date",
    "premium_value_date",
    "selected_contract",
    "trade_date",
    "updated_at",
    "valuation_date",
    "value_date",
  ];
  apiService
    .getAll(params)
    .then((data) => {
      data = JSON.parse(JSON.stringify(data));
      // parse expo
      data[0].expo.forEach(function(d) {
        for (let i = 0; i < dateFieldsExpo.length; i++) {
          d[dateFieldsExpo[i]] = timeParseNoNull2(d[dateFieldsExpo[i]]);
        }
        d.unit_change = 1;
      });
      // parse hedge
      data[0].hedge.forEach(function(d) {
        for (let i = 0; i < dateFieldsHedge.length; i++) {
          d[dateFieldsHedge[i]] = timeParseNoNull2(d[dateFieldsHedge[i]]);
        }
        d.date = d.fixing_date;
        d.notional = +d.notional;
        d.quantity_hedge = +d.notional;
        d.settlement_rate_hedge =
          d.settlement_rate == null ? null : d.settlement_rate;
        d.cash_flow = 0;
        d.balance = 0;
      });
      _this[fieldName] = data;
      _this[fieldShowLoadingName] = false;
    })
    .catch(function(error) {
      _this[fieldName] = [];
      _this[fieldShowLoadingName] = false;
      console.error(error);
    });
}
